// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V96eTMauHP8kTH {
  bottom: var(--ds-space-200, 16px);
  transition: bottom 0.3s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}
.V96eTMauHP8kTH.fKbeKeWe8c33wz {
  bottom: -100px;
}
.V96eTMauHP8kTH.Zfon2urYIUf4eI {
  transform: translateY(100px);
  opacity: 0;
  pointer-events: none;
}
.h38TalBaid8h4h {
  bottom: var(--ds-space-0, 0);
  border-top: 1px solid var(--ds-border, #dfe3e8);
}
.h38TalBaid8h4h > div > div:last-child {
  flex: 0 0 36px;
}
.vrBCNv7EmVFPOl {
  display: flex;
  flex-direction: row;
  gap: var(--ds-space-075, 6px);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: 1px;
}
`, ""]);
// Exports
export var configurationPanels = `V96eTMauHP8kTH`;
export var isCardRoute = `fKbeKeWe8c33wz`;
export var hiddenForBulkActions = `Zfon2urYIUf4eI`;
export var configurationTabs = `h38TalBaid8h4h`;
export var horizontalRow = `vrBCNv7EmVFPOl`;
export default ___CSS_LOADER_EXPORT___;
